import { ChatStatus } from '../../chat/chat-status.enum';
import { RandomGenerator } from '../../../..';
var SmsChannelDataBuilder = /** @class */ (function () {
    function SmsChannelDataBuilder() {
        this.smsChannelData = {
            participantIds: [],
            activeParticipantIds: [],
            chatId: '111-000',
            chatStatus: ChatStatus.WAITING,
            chatStatusLastUpdateDate: 0,
            userPhoneNumber: RandomGenerator.randomPhoneNumber(),
            lineId: '222-111'
        };
    }
    SmsChannelDataBuilder.prototype.withParticipantIds = function (participantIds) {
        this.smsChannelData.participantIds = participantIds;
        return this;
    };
    SmsChannelDataBuilder.prototype.withActiveParticipantIds = function (activeParticipantIds) {
        this.smsChannelData.activeParticipantIds = activeParticipantIds;
        return this;
    };
    SmsChannelDataBuilder.prototype.withChatId = function (chatId) {
        this.smsChannelData.chatId = chatId;
        return this;
    };
    SmsChannelDataBuilder.prototype.withChatStatus = function (chatStatus) {
        this.smsChannelData.chatStatus = chatStatus;
        return this;
    };
    SmsChannelDataBuilder.prototype.withChatStatusLastUpdateDate = function (chatStatusLastUpdateDate) {
        this.smsChannelData.chatStatusLastUpdateDate = chatStatusLastUpdateDate;
        return this;
    };
    SmsChannelDataBuilder.prototype.withLineId = function (lineId) {
        this.smsChannelData.lineId = lineId;
        return this;
    };
    SmsChannelDataBuilder.prototype.withUserPhoneNumber = function (userPhoneNumber) {
        this.smsChannelData.userPhoneNumber = userPhoneNumber;
        return this;
    };
    SmsChannelDataBuilder.prototype.build = function () {
        return this.smsChannelData;
    };
    return SmsChannelDataBuilder;
}());
export { SmsChannelDataBuilder };
//# sourceMappingURL=sms-channel-data.builder.js.map